<div class="content">
  <button (click)="close()">已悉知</button>
</div>
